import { useState, useCallback } from 'react';

const MAX_HISTORY = 50;

/**
 * Hook para undo/redo de texto en el editor de notas.
 * Retorna [value, setValue, { undo, redo, canUndo, canRedo }]
 */
export const useUndoRedo = (initialValue = '') => {
  const [history, setHistory] = useState({
    past: [],
    present: initialValue,
    future: [],
  });

  const setValue = useCallback((newValue) => {
    setHistory((h) => ({
      past: [...h.past, h.present].slice(-MAX_HISTORY),
      present: newValue,
      future: [],
    }));
  }, []);

  const undo = useCallback(() => {
    setHistory((h) => {
      if (h.past.length === 0) return h;
      const previous = h.past[h.past.length - 1];
      return {
        past: h.past.slice(0, -1),
        present: previous,
        future: [h.present, ...h.future],
      };
    });
  }, []);

  const redo = useCallback(() => {
    setHistory((h) => {
      if (h.future.length === 0) return h;
      const next = h.future[0];
      return {
        past: [...h.past, h.present],
        present: next,
        future: h.future.slice(1),
      };
    });
  }, []);

  const reset = useCallback((value) => {
    setHistory({ past: [], present: value, future: [] });
  }, []);

  return [
    history.present,
    setValue,
    {
      undo,
      redo,
      reset,
      canUndo: history.past.length > 0,
      canRedo: history.future.length > 0,
    },
  ];
};
